module.exports = __webpack_public_path__ + "img/background.eeb0d2c2.jpg";